<template>
<div class="friend">

	<!-- 头部 -->
	<zmlmenupage cn-name='合作伙伴' en-name='Cooperative Partner'></zmlmenupage>


	<zmlpagebanner banner-img='static/img/aboutBanner.png' banner-text='货运江湖，一键启航！' cn-name='合作伙伴' en-name='Cooperative Partner'>
	</zmlpagebanner>

	<div class="friend-con">
		<div class="info friendInfo">
			<span class="friend-title">合作伙伴</span>
			<div class="friend-list">
				<!-- <div class="friend-item">
						<img src="../../static/img/friend1.png" width="250" height="120" alt="">
					</div>
					<div class="friend-item">
						<img src="../../static/img/friend2.png" width="250" height="120" alt="">
					</div> -->
				<div class="friend-item">
					<img src="../../static/img/friend3.png" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend4.png" width="250" height="120" alt="">
				</div>
				<!-- <div class="friend-item">
						<img src="../../static/img/friend5.png" width="250" height="120" alt="">
					</div> -->
				<!-- <div class="friend-item">
						<img src="../../static/img/friend6.png" width="250" height="120" alt="">
					</div> -->
				<div class="friend-item">
					<img src="../../static/img/friend7.png" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend8.png" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend9.jpg" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend10.jpg" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend11.jpg" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend12.jpg" width="250" height="120" alt="">
				</div>
				<div class="friend-item">
					<img src="../../static/img/friend13.jpg" width="250" height="120" alt="">
				</div>
			</div>
		</div>
	</div>
	<gototop></gototop>
</div>
</template>
<script>
export default {
	name: 'friend',
	data() {
		return {

		}
	}
}
</script>
<style scoped="scoped">
.friendInfo {
	padding: 100px 0 200px;
}

.friend-title {
	font-weight: bold;
	font-size: 28px;
}

.friend-list {
	width: 100%;
	height: auto;
	padding: 76px;
	display: flex;
	flex-wrap: wrap;
}

.friend-item {
	margin: 3px 30px;
	/* border: 1px solid #ccc; */
}

@media only screen and (max-width: 750px) {
	.friend {
		height: calc(100% - 36px);
		overflow: auto;
	}
	.friendInfo {
		padding: 0;
	}
	.friend-title {
		display: block;
		/* line-height: 63px; */
		background-color: #F4F4F6;
		padding: 23px;
		font-size: 14px;
		font-weight: bold;
	}
	.friend-list {
		padding: 23px;
		justify-content: space-between;
	}
	.friend-item {
		margin: 0;
		width: 48%;
		/* border: 0; */
		margin-bottom: 10px;
	}
	.friend-item img {
		width: 100%;
		height: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/friend.vue